import { MediaType } from '../../../@repo-level/core-front/helpers/enums';
import { SliderParams } from './Games';

export enum Categories {
  RECENT = 'recent',
  WAGERING = 'bonus_wagering',
  FAVORITES = 'favorites',
  LUCKY_HITS = 'lucky_hits',
  TOP = 'top',
  NEW = 'new',
  BONUS_BUY = 'bonus_buy',
  LIVE = 'live',
  INSTANT = 'instant',
  JACKPOT = 'jackpot',
  TABLE = 'table',
  SLOTS = 'slots',
}

export const oneRowSliderParams: Record<MediaType, SliderParams> = {
  [MediaType.DESKTOP_L]: { cols: 7, allGames: 21, rows: 1 },
  [MediaType.DESKTOP]: { cols: 6, allGames: 18, rows: 1 },
  [MediaType.TABLET]: { cols: 4, allGames: 16, rows: 1 },
  [MediaType.MOBILE]: { cols: 3, allGames: 11, rows: 1 },
  [MediaType.MOBILE_S]: { cols: 2, allGames: 11, slidesPerView: 2.2, rows: 1 },
};

export const twoRowsSliderParams: Record<MediaType, SliderParams> = {
  [MediaType.DESKTOP_L]: { cols: 7, allGames: 42, rows: 2 },
  [MediaType.DESKTOP]: { cols: 6, allGames: 36, rows: 2 },
  [MediaType.TABLET]: { cols: 4, allGames: 32, rows: 2 },
  [MediaType.MOBILE]: { cols: 3, allGames: 25, rows: 2 },
  [MediaType.MOBILE_S]: { cols: 2, allGames: 25, slidesPerView: 2.2, rows: 2 },
};

export const BONUS_BUY_SLIDER_PARAMS: Record<MediaType, SliderParams> = {
  [MediaType.DESKTOP_L]: { cols: 7, allGames: 21, rows: 1 },
  [MediaType.DESKTOP]: { cols: 6, allGames: 18, rows: 1 },
  [MediaType.TABLET]: { cols: 4, allGames: 16, rows: 1 },
  [MediaType.MOBILE]: { cols: 2, allGames: 25, rows: 2 },
  [MediaType.MOBILE_S]: { cols: 2, allGames: 25, slidesPerView: 2.2, rows: 2 },
};

export const JACKPOT_SLIDER_PARAMS: Record<MediaType, SliderParams> = {
  [MediaType.DESKTOP_L]: { cols: 7, allGames: 21, rows: 1 },
  [MediaType.DESKTOP]: { cols: 6, allGames: 18, rows: 1 },
  [MediaType.TABLET]: { cols: 4, allGames: 16, rows: 1 },
  [MediaType.MOBILE]: { cols: 2, allGames: 25, rows: 2 },
  [MediaType.MOBILE_S]: { cols: 2, allGames: 25, slidesPerView: 2.2, rows: 2 },
};

export const LIVE_SLIDER_PARAMS: Record<MediaType, SliderParams> = {
  [MediaType.DESKTOP_L]: { cols: 7, allGames: 21, rows: 1 },
  [MediaType.DESKTOP]: { cols: 6, allGames: 18, rows: 1 },
  [MediaType.TABLET]: { cols: 4, allGames: 16, rows: 1 },
  [MediaType.MOBILE]: { cols: 2, allGames: 25, rows: 2 },
  [MediaType.MOBILE_S]: { cols: 2, allGames: 25, slidesPerView: 2.2, rows: 2 },
};

export const TABLE_SLIDER_PARAMS: Record<MediaType, SliderParams> = {
  [MediaType.DESKTOP_L]: { cols: 7, allGames: 21, rows: 1 },
  [MediaType.DESKTOP]: { cols: 6, allGames: 18, rows: 1 },
  [MediaType.TABLET]: { cols: 4, allGames: 16, rows: 1 },
  [MediaType.MOBILE]: { cols: 2, allGames: 25, rows: 2 },
  [MediaType.MOBILE_S]: { cols: 2, allGames: 25, slidesPerView: 2.2, rows: 2 },
};
